module.exports = __webpack_public_path__ + "static/media/Crestwood-Manor-in-Northville.4d36c066.pdf";